const getAssessmentBottomBarObject = (theme) => {
  return {
    bottomBar: {
      padding: "10px 30px",
      backgroundColor: "white",
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      borderTop: "1px solid #0304041A",
      zIndex: 2000,
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
    nextButton: {
      backgroundColor: "#d9dbdc",
      color: "#878888",
    },
    nextButtonActive: {
      backgroundColor: theme.assessment.btnColor,
      color: " white",
    },
    backButton: {
      borderColor: theme.assessment.btnBorderColor,
      color: "#09306d",
    },
    bottomBarButton: {
      textTransform: "none",
      fontWeight: "bold",
      padding: "10px",
    },
    guidedBottomBarButton: {
      padding: "12px 25px 12px 25px",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0px",
      fontWeight: 600,
      backgroundColor: "#0D47A1",
      color: "#fff",
    },
  };
};

export const getAssessmentBottomBarStyle = getAssessmentBottomBarObject;
